export default "__VITE_ASSET__46c0d11e__"